import React from 'react';
import AnalyticsReportBuilder from './AnalyticsReportBuilder/AnalyticsReportBuilder';

const ReportBuilder = ({ isRTL = false, companyUID = '', analyticsActorId = 'system' }) => (
  <AnalyticsReportBuilder isRTL={isRTL} companyUID={companyUID} analyticsActorId={analyticsActorId} />
);

export default ReportBuilder;
